export enum CardStatus{
  fulfilled = 'fulfilled',
  empty = 'empty',
}
